<template>
  <div class="content-wrapper">
    <ContentHeader title="Дисконтные карты" />
    <div class="content-body">
      <div class="row">
        <div class="col-xs-12">
          <card
            headerTitle="Список карт"
            :busy="isDiscountCardsLoading"
            hideFooter
            @reload="reloadDiscountCards"
          >
            <template slot="block">
              <div style="margin-bottom: 40px">
                <div class="float-xl-right float-sm-none mt10">
                  <button
                    class="btn btn-success btn-min-width bg-green bg-darken-3 btn-hover"
                    style="margin-left: 10px"
                    @click="showModal = true"
                  >
                    <i class="icon-plus3" style="padding-right: 15px"></i>
                    Добавить карту
                  </button>
                </div>
                <div>
                  <p style="padding-left: 10px">
                    Максимальное количество дисконтных карт - 3 карты.
                  </p>
                </div>
              </div>
              <b-table
                show-empty
                hover
                bordered
                responsive
                thead-class="bg-grey bg-lighten-2"
                :emptyText="
                  isDiscountCardsFailed
                    ? 'Ошибка подключения. Попробуйте позже'
                    : 'Записи отсутствуют'
                "
                emptyFilteredText="Записи не найдены"
                :busy="isDiscountCardsLoading"
                :items="getDiscountCards"
                :fields="discountCardsFields"
              >
                <template v-slot:cell(card_id)="data">
                  <div>
                    <span
                      class="btn-link"
                      @click="qrcodeValue = data.value.toString(); qrcodeShow = true"
                      style="cursor:pointer;"
                    >{{ data.value }}</span>
                  </div>
                </template>
                <template v-slot:cell(status)="data">
                  <span
                    class="tag tag-default"
                    :class="{
                      'bg-warning bg-red bg-darken-2':
                        data.value === 'Заблокирована',
                      'bg-green bg-darken-1': data.value === 'Активна',
                    }"
                    >{{ data.value }}</span
                  >
                </template>
                <template v-slot:cell(actions)="row">
                  <div class="text-xs-center">
                    <span
                      class="btn-link"
                      :class="{ 'text-muted': row.item.block }"
                      title="Заблокировать"
                      style="cursor: pointer"
                      @click="
                        if (!row.item.block) {
                          showBlockModal = true;
                          discountCardNumber = row.item.card_id;
                        }
                      "
                      :disabled="row.item.block"
                    >
                      <i
                        class="icon-lock4 font-medium-5"
                        :class="{ ' icon-hover indigo': !row.item.block }"
                      ></i>
                    </span>
                    <!--span
                      class="btn-link"
                      title="Удалить"
                      style="cursor: pointer;"
                      @click="showRemoveModal = true; discountCardNumber = row.item.card_id"
                    >
                      <i class="icon-android-delete font-medium-5 icon-hover indigo"></i>
                    </span-->
                  </div>
                </template>
              </b-table>
            </template>
          </card>
        </div>
      </div>
      <!-- Транзакции по дисконтным картам -->
      <BillTable
        title="Детализация по дисконтным картам"
        downloadFilename="Детализация по дисконтным картам"
        :fields="discountTransactionsFields"
        :items="getDiscountTransactions"
        :busy="isDiscountTransactionsLoading"
        :failed="isDiscountTransactionsFailed"
        @reload="reloadDiscountTransactions"
      ></BillTable>
      <!-- Добавление карты -->
      <modal
        :id="modalId"
        v-if="showModal"
        @close="closeModal"
        @cancel="closeModal"
        @ok="addDiscountCard"
      >
        <template slot="header-title">ДОБАВЛЕНИЕ КАРТЫ</template>
        <template slot="body">
          <div class="row">
            <div class="col-xs-4 text-xs-right">
              <p style="padding-top: 8px">Номер карты</p>
            </div>
            <div class="col-xs-8">
              <input
                type="number"
                placeholder="Укажите номер карты"
                class="form-control"
                min="1"
                v-model="discountCardNumber"
                @input="discountCardNumberErrorShow = false"
              />
              <p class="text-danger" v-if="discountCardNumberErrorShow">
                {{ discountCardNumberError }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-4 text-xs-right">
              <p style="padding-top: 8px">Держатель</p>
            </div>
            <div class="col-xs-8">
              <input
                type="text"
                placeholder="Укажите имя держателя"
                class="form-control"
                v-model="discountCardHolder"
              />
            </div>
          </div>
          <p class="text-xl-right" v-if="getDiscountCards.length >= 3">
            <span class="tag tag-default bg-yellow bg-darken-3 text-xl-right"
              >Внимание!</span
            >
            <br />К сожалению, Вы не можете добавить карту, у Вас превышен
            лимит. Максимальное количество дисконтных карт - 3 карты.
          </p>
        </template>
        <template slot="ok-title">
          <template v-if="getDiscountCards.length >= 3">Закрыть</template>
          <template v-else>Добавить</template>
        </template>
      </modal>
      <!-- Удаление карты -->
      <modal
        :id="removeModalId"
        v-if="showRemoveModal"
        @close="closeModal"
        @cancel="closeModal"
        @ok="removeDiscountCard"
      >
        <template slot="header-title">Подтвеждение</template>
        <template slot="body">
          <p>Нажимая ОК Вы подтверждаете удаление топливной карты.</p>
        </template>
      </modal>
      <!-- Блокировка карты -->
      <modal
        :id="blockModalId"
        v-if="showBlockModal"
        @close="closeModal"
        @cancel="closeModal"
        @ok="blockDiscountCard"
      >
        <template slot="header-title">Подтвеждение</template>
        <template slot="body">
          <p>Нажимая ОК Вы подтверждаете блокировку топливной карты.</p>
        </template>
      </modal>
      
          <qrcodeModal
            v-if="qrcodeShow"
            :value="qrcodeValue"
            @close="qrcodeShow = false"
          />
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BillTable from "@/components/BillTable.vue";
import modal from "@/components/modal.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import {
  DISCOUNT_REQUEST,
  DISCOUNT_ADD_REQUEST,
  DISCOUNT_REMOVE_REQUEST,
  DISCOUNT_BLOCK_REQUEST,
  DISCOUNT_TRANSACTIONS_REQUEST,
} from "@/store/actions/discount.js";
import qrcodeModal from '@/components/qrcodeModal.vue';

export default {
  name: "Discount",
  components: {
    ContentHeader,
    BillTable,
    modal,
    card,
    qrcodeModal,
  },
  data() {
    return {
      modalId: "modal",
      showModal: false,

      removeModalId: "modal-remove",
      showRemoveModal: false,

      blockModalId: "modal-block",
      showBlockModal: false,

      discountCardNumber: null,
      discountCardHolder: " ",
      discountCardNumberError: "",
      discountCardNumberErrorShow: false,

      qrcodeValue: "",
      qrcodeShow: false,

      discountCardsFields: [
        {
          key: "card_id",
          label: "№ Карты",
        },
        {
          key: "holder_name",
          label: "Держатель",
        },
        {
          key: "status",
          label: "Состояние",
          formatter: (value, key, item) => {
            return item.block ? "Заблокирована" : "Активна";
          },
        },
        {
          key: "actions",
          label: "Управление",
          thClass: "text-xs-center",
          thStyle: { width: "100px" },
        },
        /*{
          key: "date",
          label: "Дата и время активации",
          formatter(value) {
            return new Date(value).toLocaleString();
          },
        },*/
      ],
      discountTransactionsFields: [
        {
          key: "date",
          label: "Дата и время",
          formatter(value) {
            return new Date(value).toLocaleString();
          },
          filterByFormatted: true,
        },
        {
          key: "card_id",
          label: "№ Карты",
        },
        {
          key: "station",
          label: "АЗС",
          formatter(value, index, item) {
            return `${item.station_name}, ${item.region_name}`;
          },
          filterByFormatted: true,
        },
        {
          key: "product_name",
          label: "НП",
        },
        {
          key: "pay_type",
          label: "Тип",
          formatter(value) {
            let pt = "";
            switch (value) {
              case 1:
                pt = "Наличные";
                break;
              case 2:
                pt = "Б\\карта";
                break;
              default:
                break;
            }
            return pt;
          },
          filterByFormatted: true,
        },
        {
          key: "full_quantity",
          label: "Отпущено, л",
        },
        {
          key: "price",
          label: "Цена, тг",
        },
        {
          key: "discount",
          label: "Скидка, тг",
        },
        {
          key: "discount_sum",
          label: "Итого скидка, тг",
        },
        {
          key: "cost",
          label: "Итого сумма, тг",
        },
        /*{
          key: "holder_name",
          label: "Держатель",
        },*/
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getDiscountCards",
      "getDiscountCardById",
      "isDiscountCardsLoading",
      "isDiscountCardsFailed",
      "discountCardsOnceLoaded",

      "getDiscountTransactions",
      "isDiscountTransactionsLoading",
      "isDiscountTransactionsFailed",
      "discountTransactionsOnceLoaded",
    ]),
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.showRemoveModal = false;
      this.showBlockModal = false;
      this.discountCardNumber = null;
      this.discountCardHolder = " ";
      this.discountCardNumberErrorShow = false;
    },
    reloadDiscountCards() {
      this.$store.dispatch(DISCOUNT_REQUEST);
    },
    addDiscountCard() {
      if (this.getDiscountCards.length >= 3) {
        this.closeModal();
        return;
      }
      if (!this.discountCardNumber) {
        this.discountCardNumberError = "Укажите номер карты";
        this.discountCardNumberErrorShow = true;
        return;
      }
      this.$store
        .dispatch(DISCOUNT_ADD_REQUEST, {
          card_id: Number(this.discountCardNumber),
          holder_name: this.discountCardHolder,
        })
        .then(() => {
          this.closeModal();
        })
        .catch((err) => {
          switch (err.response.data.error) {
            case "card does not exist":
              this.discountCardNumberError = "Такой карты не существует";
              break;
            case "card is not sold":
              this.discountCardNumberError =
                "Карта не была продана. Обратитесь в офис";
              break;
            case "card is already activated":
              this.discountCardNumberError = "Данная карта уже привязана";
              break;
            default:
              this.discountCardNumberError = err.response.data.error;
              break;
          }
          this.discountCardNumberErrorShow = true;
        });
    },
    removeDiscountCard() {
      this.discountCardNumberErrorShow = false;

      this.$store
        .dispatch(DISCOUNT_REMOVE_REQUEST, {
          card_id: Number(this.discountCardNumber),
        })
        .then(() => {
          this.closeModal();
        })
        .catch((err) => {
          switch (err.response.data.error) {
            case "card does not exist":
              this.discountCardNumberError = "Такой карты не существует";
              break;
            case "card is not activated":
              this.discountCardNumberError =
                "Карта не активирована. Обратитесь в офис";
              break;
            case "not your card":
              this.discountCardNumberError = "Это не ваша карта";
              break;
            default:
              this.discountCardNumberError = err.response.data.error;
              break;
          }
          this.discountCardNumberErrorShow = true;
        });
    },
    blockDiscountCard() {
      this.discountCardNumberErrorShow = false;

      this.$store
        .dispatch(DISCOUNT_BLOCK_REQUEST, {
          card_id: Number(this.discountCardNumber),
        })
        .then(() => {
          this.closeModal();
        })
        .catch((err) => {
          switch (err.response.data.error) {
            case "card does not exist":
              this.discountCardNumberError = "Такой карты не существует";
              break;
            case "card is not activated":
              this.discountCardNumberError =
                "Карта не активирована. Обратитесь в офис";
              break;
            case "not your card":
              this.discountCardNumberError = "Это не ваша карта";
              break;
            default:
              this.discountCardNumberError = err.response.data.error;
              break;
          }
          this.discountCardNumberErrorShow = true;
        });
    },
    reloadDiscountTransactions() {
      this.$store.dispatch(DISCOUNT_TRANSACTIONS_REQUEST);
    },
  },
  beforeMount() {
    // use this component's unique client-side Vue ID
    this.modalId = `modal-${this._uid}`;
    this.removeModalId = `modal-remove-${this._uid}`;
    this.blockModalId = `modal-block-${this._uid}`;
  },
  created() {
    if (!this.discountCardsOnceLoaded) this.$store.dispatch(DISCOUNT_REQUEST);
    if (!this.discountTransactionsOnceLoaded)
      this.$store.dispatch(DISCOUNT_TRANSACTIONS_REQUEST);
  },
};
</script>